<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="dismissSuccessModal()">
        <svg-icon src="./assets/images/icons/close.svg"></svg-icon>
    </button>
</div>
<div class="modal-body text-center">
    <svg-icon src="./assets/images/icons/checked_gradient.svg" [svgStyle]="{'width.px':50}" class="d-block mb-3 mb-md-4"></svg-icon>
    <h4 class="font-weight-semibold mb-1 mb-md-2">Reminder Sent</h4>
    <p class="mb-2 mb-md-3 mb-lg-4">Your reminder notification has been sent successfully to the user group member.</p>
</div>